import React from 'react';
import { Icon } from '@iconify/react';
import revampData from '../../data/revampData.json';

const FeaturesGrid = () => {
  const featuresData = revampData.data.listFeatureHighlights.data;

  return (
    <div className='px-4 pb-4 font-figtree'>
      <div className="px-lg-4 px-1 row py-lg-5 pb-3 d-flex flex-column gap-lg-4 gap-2 m-auto">
        {featuresData.map((category, index) => (
          <div className="row mb-lg-5 mb-1 px-0 mx-0 category-card px-sm-3  px-0 align-items-center" key={index}>
            <div
              className={`col-lg-6  category-txt-container d-flex align-items-center justify-content-center order-1 order-lg-${index % 2 === 0 ? "1" : "2"}`}
            >
              <div className="text-start txt-color">
                {category.subtitle && (
                  <div className='d-flex gap-2 align-items-center mb-2 category-subtitle'>
                    <h6 style={{ color: "#002E6E" }} className="text-muted sub-title m-0">
                      {category.subtitle}
                    </h6>
                    <img src="/img/India_badge.svg" alt="" />
                  </div>
                )}
                <h3 className=" category-heading">{category.title}</h3>

                <p className="category-desc txt-color ">{category.description}</p>
                {category.features && (
                  <ul style={{ paddingLeft: index % 2 === 0 ? "20px" : "35px" }} className="list-unstyle pl-0 mt-2 mb-0">
                    {category.features.map((feature, idx) => (
                      feature && (
                        <li style={{ paddingLeft: "0px" }} className={`category-desc  ${index % 2 === 0 ? "" : "ps-2"}`} key={idx}>  {feature}</li>
                      )
                    ))}
                  </ul>
                )}
                <p className="category-desc mb-3 " style={{ color: "#475467" }}>{category.info}</p>
                <div className="d-flex mt-3 gap-3">
                  {category.icons && category.icons.map((icon, idx) => (
                    icon && (
                      <div key={idx} className='d-flex gap-4 rounded-circle' style={{ width: "48px", height: "48px", backgroundColor: "#E1F0FF" }}>
                        <Icon
                          icon={icon}
                          className="m-auto"
                          style={{ fontSize: "1.5rem", color: "#002E6E" }}
                        />
                      </div>
                    )
                  ))}
                </div>
              </div>
            </div>

            <div
              className={`col-lg-6 img-h-container d-flex align-items-center justify-content-center order-2 order-lg-${index % 2 === 0 ? "2" : "1"}`}
            >
              <img
                src={category.image}
                alt={category.title}
                className="img-fluid m-auto rounded"
              />
            </div>
          </div>
        ))}
      </div>

      {/* Style */}
      <style jsx>{`
        .category-txt-container, .img-h-container {
          height: 100%; 
        }

        .img-fluid {
          max-width: 100%;
          max-height: 500px;
          object-fit: contain;
          width: auto;
          height: auto;
        }

        .category-heading {
          font-weight: 600;
          font-size: 30px;
          line-height: 38px;
          color: #101828;
        }
        .txt-color{
          color:#475467 !important;
          font-size:18px !important;
          font-weight: 400;
        }

        .category-desc , {
          font-weight: 400;
          font-size: 18px;
          line-height: 28px;
          color: #475467;
        }

        @media screen and (max-width: 992px) {
          .category-txt-container {
            padding: 32px 16px;
          }

          .img-h-container {
            max-height: 400px;
            padding: 32px 16px;
          }

          .img-fluid {
            max-width: 400px;
          }
        }

        @media screen and (max-width: 576px) {
          .category-txt-container {
            padding: 32px 0px;
          }
          .img-fluid {
            max-width: 280px;
            max-height: 209px;
          }

          .category-subtitle {
            font-size: 14px !important;
          }
          .sub-title{
          font-size:14px !important;
          white-space:nowrap;
        }
        }
      `}</style>
    </div>
  );
};

export default FeaturesGrid;
